import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Transition as ReactTransition } from 'react-transition-group';
import Velocity from 'velocity-animate';

import WelcomeNotice from '@component/welcome/welcome-notice';
import CookieWall from '@component/welcome/cookie-wall';

import Router from '@module/router';

export const STEP_TERMS_AND_CONDITIONS = 'STEP_TERMS_AND_CONDITIONS';
export const STEP_COOKIES = 'STEP_COOKIES';
const STEPS = [STEP_TERMS_AND_CONDITIONS, STEP_COOKIES];

const onExit = (component) => {
  Velocity(
    component,
    {
      scale: '1.3',
      opacity: 0,
    },
    { duration: 300 }
  );
};

export const Welcome = ({ step, in: inProp }) => {
  const className = classnames('welcome', {
    'welcome--tandc': step === STEP_TERMS_AND_CONDITIONS,
    'welcome--cookies': step === STEP_COOKIES,
  });

  // When a panel is open this will close it
  // when the user clicks on the main window
  const closePanel = () => {
    Router.navigateTo(Router.getLastRoute('transfer', '/'));
  };

  return (
    <div className={className}>
      <ReactTransition
        in={inProp}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={onExit}
      >
        <div className="welcome__background" />
      </ReactTransition>
      <ReactTransition
        in={inProp}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={onExit}
      >
        <div className="welcome__container">
          <div className="welcome__cover" onClick={closePanel} />
          <div className="welcome__content">
            {step === STEP_TERMS_AND_CONDITIONS && (
              <WelcomeNotice closePanel={closePanel} />
            )}
            {step === STEP_COOKIES && <CookieWall closePanel={closePanel} />}
          </div>
        </div>
      </ReactTransition>
    </div>
  );
};

Welcome.propTypes = {
  step: PropTypes.oneOf(STEPS),
  session: PropTypes.object.isRequired,
  in: PropTypes.bool.isRequired,
};

Welcome.defaultProps = {
  step: STEPS[0],
};

const mapStateToProps = ({ session }) => ({ session });

export default connect(mapStateToProps)(Welcome);
